<template>
	<div class="accountSetting pl-xl-4">
        <div class="border-bottom pb-1 mb-4">
    		<h3 class="medium "> Device Manager</h3>
            <p>List of all devices from which you have logged in.</p>
            <p class="position-relative my-4 pl-5"><span class="alertTriangle position-absolute red"><feather type="alert-triangle"></feather> </span>By adding one or more IP Address to the list, you will be allowed to place orders or withdraw funds from those mentioned address. If you wish to add or remove an IP Address, you need to have the Two Factor Authentication (2FA) enabled as well as providing the authenticator code before submitting for changes.</p>
        </div>
        <div class="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-between">
            <h5 class="medium mb-0 d-flex align-items-center"><img class="mr-2" src="../../../../../static/website/images/lapIcon.png" alt="Device" title="My devices"> <span class="secondary">My devices</span></h5>
            <a @click.prevent="addip = !addip" href="javascript:void(0)" class="cap_btn-b small py-2">Add New IP Address</a> 
        </div>
        <section class="add_ipaddress px-0 pb-md-5" :class="addip?'d-block':'d-none'">
            <div class="customMid-IP">
                <alert-notification v-if="notification_msg != ''"/>
            </div>
            <div class="section_title">
                <h5>Add New IP Address</h5>
            </div>
            <div class="custom-IP-section">
                <div class="row  justify-content-center">
                    <loader v-if="pageLoader"></loader>
                    <div class="mx-auto col-12 text-center" v-else-if="transaction_id == ''">
                        <div class="form-group customMid-IP">
                        <div class="submitIP">
                            <vue-ip-input :ip="ipAddress" :on-change="onIpChange" :on-blur="onIpBlur" v-model="ipAddress"/>
                            <input v-validate="'required|ip'" data-vv-as="ip" name="ip_field" type="text" v-model="ipAddress" style="display: none;">
                        </div>
                        <span class="text-danger" v-if="submitted && errors.has('ip_field')">{{ errors.first('ip_field') }}</span>
                       </div>
                        <div class="form-group text-center mt-3">
                            <input type="submit" class="cap_btn blue px-4 large_btn" name="" value="Save Address" :class="(pageLoader)?'disabled':''"  @click="submit()">
                        </div>
                    </div>
                    <div class="col-12 text-center max-500" v-else-if="transaction_id != '' && parseInt(get_user.profile.gAuthenticatorEnabled) == 0 ">
                        <p class="mb-0">  Two factor authentication is disabled on your account. And as a security measure, we cannot Add IP unless 2FA is enabled.</p>
                        <div class="form-group text-center mt-3">
                            <input type="submit" class="cap_btn blue px-4 large_btn" name="" value="Enable 2fa" @click="$parent.otp_allow = true">
                        </div>
                    </div>
                    <div class="col-12 text-center" v-else-if="transaction_id != '' && parseInt(get_user.profile.gAuthenticatorEnabled) == 1">
                        <div class="form-group customMid-IP">
                            <div class="position-relative">
                                <input type="text" class="form-control" name="otp" v-model="otp" v-validate="'required|digits:6'" placeholder=" ">
                                <label class="labeltext">Enter Google Authenticator Otp</label>
                                <span v-if="submitted && errors.has('otp')" class="text-danger">{{ errors.first('otp') }}</span>
                            </div>
                        </div>
                        <!-- <div class="form-group">
                            <div class="submitIP">
                                <h1>Enter Otp</h1>
                                <input v-validate="'required|digits:6'" name="otp" type="text" v-model="otp" >
                            </div>
                            <span class="text-danger" v-if="submitted && errors.has('otp')">{{ errors.first('otp') }}</span>
                        </div> -->
                        <div class="form-group text-center mt-3">
                            <input type="submit" class="cap_btn blue px-4 large_btn"  :class="(pageLoader)?'disabled':''" name="" value="Submit" @click="CheckOtp()">
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="marketData table-responsive smallFont">
            <ip-list></ip-list>

           <!--  <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>Device</th>
                        <th>Browser</th>
                        <th>IP Address</th>
                        <th>Near</th>
                        <th>Signed In</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Windows 10</td>
                        <td>Chrome (Mac)</td>
                        <td>92.15.95.26</td>
                        <td>United Kingdom, High Wycombe</td>
                        <td>less than a minute ago</td>
                        <td><a href="javascript:void(0)"><feather size="16px" type="x"></feather> </a></td>
                    </tr>
                    <tr>
                        <td>iPhone 12</td>
                        <td>Mozilla Firefox (Mac)</td>
                        <td>81.178.248.70</td>
                        <td>United Kingdom, High Wycombe</td>
                        <td>about 23 hours ago</td>
                        <td><a href="javascript:void(0)"><feather size="16px" type="x"></feather> </a></td>
                    </tr>
                    <tr>
                        <td>macOS Catalina 10.15</td>
                        <td>Chrome (Mac)</td>
                        <td>92.15.95.26</td>
                        <td>United Kingdom, High Wycombe</td>
                        <td>less than a minute ago</td>
                        <td><a href="javascript:void(0)"><feather size="16px" type="x"></feather> </a></td>
                    </tr>
                    
                </tbody>
            </table> -->
        </div>
        <div class="buttons d-flex align-items-center justify-content-end border-top pt-4 mt-4">
            <a href="javascript:void(0)" class="cap_btn-b mr-3 min-auto">Cancel</a>
            <a href="javascript:void(0)" class="cap_btn">Save</a>
        </div>
		
    </div>
</template>

<script>
var VueIpInput = require('vue-ip-input');
import { userOperationMixins } from '@/plugins/userOperation'
import iplist from '../../ip-whiteList/list'
export default {
    name: 'Create-Ip',
    mixins: [userOperationMixins],
    data(){
        return {
            pageLoader: false,
            notification_msg:'',
            notification_type:'',
            ipAddress: '',
            submitted: false,
            addip: false,
            transaction_id : '',
            otp : '',
        }
    },
    components: {
        'vue-ip-input': VueIpInput,
        ipList : iplist,
    },
    methods: {
        onIpChange: function(ip) {
            this.ipAddress = ip
        },
        onIpBlur: function (ip) {
            this.ipAddress = ip
        },
        submit(){
            if(this.pageLoader){return;}
            const _that = this
            _that.submitted = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json={
                        'globalParams' :{
                            ip_address : _that.ipAddress
                        },
                        'localParams' :{ "parameter" : _that, step: 1}
                    }
                    _that._runAddIpAddress(input_json)
                }
            });
        },
        CheckOtp(){
            if(this.pageLoader){return;}
            const _that = this
            _that.submitted = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json={
                        'globalParams' :{
                            'ip_address' : _that.ipAddress,
                            'otp' : _that.otp,
                            'trans_id' : _that.transaction_id
                        },
                        'localParams' :{ "parameter" : _that, step: 2}
                    }
                    _that._runAddIpAddress(input_json)
                }
            });
        },
        getIpList(){
            if(this.pageLoader){return;}
            this.ipAddress = '...'
            this.transaction_id = ''
            this.otp = ''
            this.submitted = false
            this._runGetIpAddressList({ 'globalParams' :{}, 'localParams':{"parameter" : this} })
        }
    },
    created(){
    }
}
</script>



// WEBPACK FOOTER //
// src/components/website/settings/files/activity.vue